import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3v18h18","key":"svg-0"}],["path",{"d":"M7 15a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M11 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M16 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M21 3l-6 1.5","key":"svg-4"}],["path",{"d":"M14.113 6.65l2.771 3.695","key":"svg-5"}],["path",{"d":"M16 12.5l-5 2","key":"svg-6"}]]

const IconChartDots2 = createReactComponent('outline', 'chart-dots-2', 'ChartDots2', __iconNode);

export default IconChartDots2;